export default __webpack_public_path__ + "static/media/down-arrow-blue.e5f41f05.svg";